
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-delivery/suppression-lists",
      function () {
        return require("private-next-pages/native-delivery/suppression-lists.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-delivery/suppression-lists"])
      });
    }
  